import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION23: PdfComponent = {
  type: 'section',
  id: 's23',
  title: '23. Notices',
  content: [
    {
      type: 'bulletList',
      id: 's23bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Any notice or similar communication given by a party under or in connection with this Agreement shall be delivered:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'by hand;',
              },
              {
                copy: 'sent by pre-paid post providing for next Business Day delivery (or pre-paid air mail if overseas) providing proof of postage; or',
              },
              {
                copy: '(subject to clause 23.3) by email,',
              },
            ],
          },
          subcopy:
            'to the recipient party at the address or email address, and for the attention of the persons, set out in clause 23.2 or such other address or email address or persons (not exceeding 2 persons) as that party may specify by notice to the other party.',
        },
        {
          copy: 'For the purposes of clause 23.1:',
          sublist: {
            bulletType: 'blank',
            content: [
              {
                copy: 'Notices to Kanda shall be sent to:',
                sublist: {
                  bulletType: 'dot',
                  content: [
                    {
                      copy: 'Address: Forward House, 17 High Street, Henley-In-Arden, Warwickshire, B95 5AA',
                    },
                    {
                      copy: 'For the attention of: Richard Fleeman',
                    },
                    {
                      copy: 'Email: help@kanda.co.uk',
                    },
                  ],
                },
              },
              {
                copy: 'Notices to Subscriber shall be sent to:',
                sublist: {
                  bulletType: 'dot',
                  content: [
                    {
                      copy: 'Address: {{COMPANY_ADDRESS}}',
                    },
                    {
                      copy: 'For the attention of: {{SIGNEE}}',
                    },
                    {
                      copy: 'Email: {{SIGNEE_EMAIL}}',
                    },
                  ],
                },
              },
            ],
          },
        },
        {
          copy: 'Notices and similar communications shall be deemed to have been received:',
          sublist: {
            bulletType: 'dot',
            content: [
              {
                copy: 'if delivered by hand, at the time of delivery to the address;',
              },
              {
                copy: 'if sent by pre-paid post, at 09.00 on the second Business Day after posting;',
              },
              {
                copy: 'if sent by pre-paid air mail, at 09.00 on the fifth Business Day after posting; and',
              },
              {
                copy: 'if sent by email, at 09.00 on the next Business Day after sending, provided that:',
              },
              {
                copy: 'the subject line of the email identifies that it is a notice being given under this Agreement; and',
              },
              {
                copy: 'a confirmatory copy is dispatched by one of the other means referred to in clause 23.1 on the same date the email was sent.',
              },
            ],
          },
          subcopy:
            'Failing either of these conditions, the email shall not constitute a valid notice.',
        },
        {
          copy: 'Faxes and electronic communications other than email are not valid notices under this Agreement.',
        },
        {
          copy: 'The preceding parts of this clause 23 do not apply to:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'the service of any proceedings or other documents in any legal action or any arbitration or other method of dispute resolution other than clause 20 (Dispute Resolution); or',
              },
              {
                copy: 'routine reporting under this Agreement, which may be in any conventional written form (including email).',
              },
            ],
          },
        },
      ],
      prefix: '23',
    },
  ],
};
